<template>
  <div class="app-content content devcontent ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
            <div class="container-fluid">
                <div class="row breadcrumbs-top">
                  <div class="col-md-12 content-header-left px-0">
                    <h3 class="content-header-title float-left mb-0" > Performance Dashboard  </h3>
                    
                    <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="#">Incentive</a>
                                </li>
                             </ol>
                        </div>
                  </div>
                </div>
            </div>
            
        </div>

        <div class="container px-0">
           
                 <div class="mr-auto text-left w-auto px-0 right_gridviewD">
                    <ul class="list-inline ">
                        <li class="list-inline-item mb-1" @click="toggleDiv('div4')" :class="{ active: activeButton === 'div4' }">
                            Add Incentive
                        </li>  
                        <li class="list-inline-item mb-1"  @click="toggleDiv('div1')" :class="{ active: activeButton === 'div1' }">
                            Vehicle Driver (On/Before time arrival) 
                        </li>
                        <li class="list-inline-item mb-1" @click="toggleDiv('div2')" :class="{ active: activeButton === 'div2' }">
                            Floor Staff (Loading & Unloading)
                        </li>
                        <li class="list-inline-item mb-1" @click="toggleDiv('div3')" :class="{ active: activeButton === 'div3' }">
                            Handlers/Labour (Depends upon overall work)
                        </li>
                           
                    </ul>

                </div>
                <div  class="container-fluid px-0" v-if="showDiv1">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Mh04HD5614</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_3.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Robin</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 9:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 9:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">235.00 </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 470.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14LB9624</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_1.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Rohit</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 10:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 10:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 300 </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 600.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH43BG6703</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_2.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Ramesh</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/24 9:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/24 12:10</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">500</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1000.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">RJ11GC6568</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_4.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Ganesh</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 4:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 4:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">100</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 200.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14LB1318</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_5.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Vishal</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 3:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 3:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">874</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1748.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14GD2113</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_6.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Nadu</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/24 12:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/24 12:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">343</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 686.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH43BG7399</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_7.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Rahul</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 9:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 9:10</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">873</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1746.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">HR55AM9958</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_8.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Vivek</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 10:00</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 10:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">912</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1824.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH20EL9585</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_9.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Santosh</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 7:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 6:30</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">236</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 472.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">RJ11GC6568</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_10.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Driver Name</h6>
                                            <p class="mb-0">Prameshwar</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-calendar font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Expected Arrival Date & time</h6>
                                            </div>
                                            <div class="font-weight-bolder text-secondary">	1/28/2024 4:30</div>
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Actual Arrival time</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">1/28/2024 4:00</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-route  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Trip Distance</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">100</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 200.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            
                    </div>
                </div>
                <div  class="container-fluid px-0" v-if="showDiv2">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14HG8468</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">SOU_29742</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">24 ft</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:00 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 470.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH12LT3985</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">VIN_33151</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">32 ft SXL</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:00 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 300.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH12LT3986</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">NIR_60674</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">32 ft MXL</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">  3:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:15 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 150.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH20BT3356</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">SAR_41744</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">20 Ft</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:00 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 1:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 300.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14HG3655</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">SUN_61543</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">24 ft</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:25 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 50.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14GD1404</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">LAXS_61513</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">32 ft SXL</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:00 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">3:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 00.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH43Y2893</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">ARC_62448</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">32 ft MXL</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:15 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 150.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14KA5337</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">AKS_62657</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">20 Ft</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:00 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 1:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 300.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">MH14HG3869</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">SUM_62658</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">24 ft</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:00 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 2:45 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 150.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row d-flex align-items-center w-100">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">HR55W4756</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/blank.png"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Staff Name</h6>
                                            <p class="mb-0">ASH_62654</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-info rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-truck font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Vehicle Type	</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary">32 ft SXL</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-danger rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-history  font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Targeted Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:30 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-warning rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-hourglass-start  font-medium-5"></em>
                                                </div>
                                                
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Actual Duration</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"> 3:15 Hrs </div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 150.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                            </div>
                           
                            
                    </div>
                </div>
                <div  class="container-fluid px-0" v-if="showDiv3">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row ">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_3.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Ramesh</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	SOU_29742</div>
                                        
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 470.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row ">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        <!-- <div class="col-auto ml-auto">
                                            <div class="font-weight-bolder text-white">1/28/24 9:30</div>
                                            </div> -->

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_4.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Rohit</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	VIN_33151</div>
                                        
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 600.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_5.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Prakash</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                           
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	NIR_60674</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1000.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_6.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Sandeep</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	SAR_41744</div>
                                        
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 200.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_7.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Kanse</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	SUN_61543</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1748.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_8.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Ganu</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	LAXS_61513</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 686.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_9.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Ganpat</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	ARC_62448</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1746.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_9.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">gajanan</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	AKS_62657</div>
                                        
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 1824.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                                <div class="card card-developer-meetup">
                                <div class="card-header p-1">

                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="font-weight-bolder text-white ">Handlers/Labour (Depends upon overall work)</div>
                                        </div>
                                        

                                    </div>
                                </div>
                                <div class="card-body card-transaction mt-2 px-1">
                                   <div class="transaction-item">
                                    <div class="media align-items-center">
                                        <div class="avatar mr-50">
                                            <img alt="" src="../../../public/images/icons/plate_photo_10.jpg"  height="52px" class="">
                                        </div>
                                        <div class="media-body">
                                            <h6 class="mb-0">Labour Name</h6>
                                            <p class="mb-0">Gaju</p>
                                        </div>
                                    </div>
                                        
                                    </div>
                                    
                                    
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-primary rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-address-card font-medium-5"></em>
                                                    
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Handler/Labour Name</h6>
                                            </div>
                                            
                                        </div>
                                        <div class="font-weight-bolder text-secondary">	SUM_62658</div>
                                    </div>
                                    <div class="transaction-item">
                                        <div class="media">
                                            <div class="avatar bg-light-success rounded">
                                                <div class="avatar-content">
                                                    <em class="las la-wallet font-medium-5"></em>
                                                </div>
                                            </div>
                                            <div class="media-body">
                                                <h6 class="transaction-title">Gained Incentive</h6>
                                               
                                            </div>
                                        </div>
                                        <div class="font-weight-bolder text-secondary"><span class="inr_rupise_symbol"> <em class="las la-rupee-sign"></em></span> 472.00</div>
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                           
                           
                            
                    </div>
                </div>
                <div  class="container-fluid px-0" v-if="showDiv4">
                    <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                    <div class="card pt-1">
                    <div class="row mx-0">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                            <label class="form-label">Incentive Name<span class="requiredField">*</span></label>
                            <input class="form-control" v-model="add_incentives.incentive_name" type="text" placeholder="Enter Incentive Name "/>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                            <label class="form-label text-left w-100">Start Date</label>
                            <date-picker placeholder="Select Start Date" v-model="add_incentives.start_date" valueType="format" class="startdate w-100" :disabled-date="pastDates"></date-picker>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                            <label class="form-label text-left w-100">End Date</label>
                            <date-picker placeholder="Select End Date" v-model="add_incentives.end_date" valueType="format" class="startdate w-100" :disabled-date="pastDates"></date-picker>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1">
                            <label class="form-label text-left w-100">Payment Date</label>
                            <date-picker placeholder="Select Payment Date" v-model="add_incentives.payment_date" valueType="format" class="startdate w-100" :disabled-date="pastDates"></date-picker>
                        </div>
                    </div>
                    <h4 class="ml-1 fc_mobileviewfontsize">Add Distance Travelled Reward Tiers</h4>
                    <div class="row mx-0 mt-1">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8 " style="display:flex; gap: 1rem">
                            <label class="form-label">Select KPI: </label>
                            <div class="radio-cntrl ml-xs-1 ml-sm-0 mr-2 radio_button_cntr  d-flex align-items-center">
                                <input id="distance" type="radio" value="distance" v-model="add_incentives.kpi">
                                <label for="distance" class="common-margin-selectkpi" > Distance </label>
                            </div>
                            <div class="radio-cntrl ml-xs-1 ml-sm-0 mr-2 radio_button_cntr d-flex align-items-center">
                                <input id="package" type="radio" value="package" v-model="add_incentives.kpi">
                                <label for="package" class="common-margin-selectkpi"> Package </label>
                            </div>
                            <div class="radio-cntrl ml-xs-1 ml-sm-0 mr-2 radio_button_cntr d-flex align-items-center">
                                <input id="weight"  type="radio" value="weight" v-model="add_incentives.kpi">
                                <label for="weight" class="common-margin-selectkpi"> Weight </label>
                            </div>
                        </div>
                    </div>
                    <div class="row mx-0">
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                            <label class="form-label">From {{getKPILabel()}}<span class="requiredField">*</span></label>
                            <input class="form-control" v-model="add_incentives.kpis.from_point" type="number" :placeholder="'Enter From ' + getKPILabel()"/>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                            <label class="form-label">To {{getKPILabel()}}<span class="requiredField">*</span></label>
                            <input class="form-control" v-model="add_incentives.kpis.to_point" type="number" :placeholder="'Enter To ' + getKPILabel()"/>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-2 mb-1 mobileview_b_8">
                            <label for="time_taken" class="form-label text-left w-100 ">Time Taken (Hours)<span class="requiredField">*</span></label>
                            <vue-timepicker name="time_taken" class="appmdldesc_input-100 timepickerview08 " type="time" id="time_taken" format="HH:mm"  v-model="add_incentives.kpis.time_taken" :minute-interval="10" :hour-range="[[0,23]]"></vue-timepicker>
                            <div class="errorinputmsg text-left " v-if="!add_incentives.kpis.time_taken">
                                Required field
                            </div>
                            <div class="errorinputmsg text-left" v-if="add_incentives.kpis.time_taken && (!add_incentives.kpis.time_taken.HH || !add_incentives.kpis.time_taken.mm)">
                                Invalid format
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-1 mobileview_b_8">
                            <label class="form-label">Payout Amount<span class="requiredField">*</span></label>
                            <input class="form-control" v-model="add_incentives.kpis.payout_amount" type="number" placeholder="Enter reward amount (Rs)"/>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mt-0 mb-1 mobileview_b_8">
                            <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="canNewTiersBeAdded()" @click="addNewTier">Add New Tier</button>   
                        </div>
                    </div>
                    <div class="container px-1">
                        <div class="table-responsive datatableview">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                    <th> Start Distance </th>
                                    <th> Final Distance </th>
                                    <th> Payout Amount </th>
                                    <th> Time Taken </th>
                                    <th> Action </th>
                                    </tr>
                                </thead>
                                <tbody v-if="add_incentives.kpis.list.length">
                                    <template v-for="(data, index) in add_incentives.kpis.list">
                                        <tr>
                                            <td data-column="Start Distance">{{data.from_point}} KM</td>
                                            <td data-column="Final Distance">{{data.to_point}} KM</td>
                                            <td data-column="Payout Amount">{{data.payout_amount}} Rs</td>
                                            <td data-column="Time Taken">{{data.time_taken.HH}}:{{data.time_taken.mm}} Hours</td>
                                            <td data-column="Action">
                                                <button type="button" class="btn-relief-danger common-btn_btn_view" style="border: none" :disabled="false" @click="removeTier(data.id)">Remove</button>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="5" class="px-0">Added tiers will be displayed here!</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="pull-right text-right col-md-12 col-sm-12 col-xs-12  mb-2 common_trs_buttons_res">
                        <button type="button" class="btn btn-relief-primary common-btn_btn_view" :disabled="!validateForm()" @click="saveIncentives()">Submit</button>
                        <button type="reset" class="btn  btn-relief-secondary common-btn_btn_view" >Cancel</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import VueElementLoading from 'vue-element-loading'
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"
import Treeselect from '@riophae/vue-treeselect'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'

export default {
  name: "IncentiveGrid",
  mixins: [common_methods, searchMasterNameList],
  data() {
    return {
        isLoading: false,
        map: null,
        showDiv1: false,
        showDiv2: false,
        showDiv3: false,
        showDiv4: true,
        activeButton: 'div4',
        isCollapsed: false,
        add_incentives: {
            incentive_name: null,
            start_date: null,
            end_date: null,
            payment_date: null,
            kpi: "distance",
            kpis: {
                id: null,
                from_point: null,
                to_point: null,
                payout_amount: null,
                time_taken: {
                    HH: '',
                    mm: ''
                },
                list: []
            }
        },
        kpi_labels: [
            { id: 'distance', label: 'Distance (KM)' },
            { id: 'package', label: 'No. of Packages' },
            { id: 'weight', label: 'Weight (KG)' },
        ]
    };
  },
  components: {
    MarkerClusterer,
    Treeselect,
    DatePicker,
    VueElementLoading,
    VueTimepicker,
  },
  mounted() {
    
  },
  methods: {
    toggleDiv(div) {
        if (this.activeButton !== div) {
            this.activeButton = div;
            this.showDiv1 = div === 'div1';
            this.showDiv2 = div === 'div2';
            this.showDiv3 = div === 'div3';
            this.showDiv4 = div === 'div4';
        }
    },
    getKPILabel() {
        return this.kpi_labels.find(kpi => kpi.id === this.add_incentives.kpi)?.label
    },
    addNewTier() {
        let id = Date.now()
        let { from_point, to_point, payout_amount, time_taken } = this.add_incentives.kpis
        console.log(time_taken)
        let newTier = { id, from_point, to_point, payout_amount, time_taken }
        this.add_incentives.kpis.list.push(newTier)
        this.resetTierForm()
    },
    removeTier(id) {
        this.add_incentives.kpis.list = this.add_incentives.kpis.list.filter(item => item.id !== id)
    },
    canNewTiersBeAdded() {
        let { from_point, to_point, payout_amount, time_taken } = this.add_incentives.kpis
        if(!from_point || !to_point || !payout_amount || (time_taken && (!time_taken.HH || !time_taken.mm))) {
            return true
        }
        return false
    },
    resetIncentiveForm() {
        this.resetTierForm()
        let data = this.add_incentives
        data.incentive_name = null
        data.start_date = null
        data.end_date = null
        data.payment_date = null
        data.time_taken = {
            HH: '',
            mm: ''
        }
        data.kpis.list = []
        data.kpis.id = null
        data.kpis.from_point = null
        data.kpis.to_point = null
        data.kpis.payout_amount = null
    },
    resetTierForm() {
        let data = this.add_incentives.kpis
        data.id = null
        data.from_point = null
        data.to_point = null
        data.payout_amount = null
        data.time_taken = {
            HH: '',
            mm: ''
        }
    },
    validateForm() {
        let { incentive_name, start_date, end_date, payment_date, kpis } = this.add_incentives
        if(!incentive_name || !start_date || !end_date || !payment_date ) {
            return false
        }

        let { list } = kpis
        if(!list.length) {
            return false
        }
        return true
    },
    saveIncentives() {
        let isValidated = this.validateForm()
        if(!isValidated) {
            this.sweetAlertSnackbar("Form was invalidated. Make sure that all reuired fields are filled out!", 'error')
            return
        }
        this.isLoading = true
        let payload = { ...this.add_incentives }
        payload.kpis = payload.kpis.list
        this.makeRequest("POST", "/incentives/create", payload)
            .then(result => {
                this.isLoading = false
                let message = result.data.message
                if(result.data.status) {
                    this.resetIncentiveForm()
                    this.sweetAlertSnackbar(message, 'success')
                } else {
                    this.sweetAlertSnackbar(message, 'error')
                }
            })
            .catch(e => {
                this.displayError(e)
            })
    }
  },
};
</script>

<style scoped>
.requiredField {
    margin-left: 2px;
    color: red
}

</style>